import { z } from 'zod';
import { objectIdSchema, isValidObjectIdSchema } from '../../utils/index.js';
import { themeSchema } from '../theme.js';
import { baseSchema, baseFESchema } from '../base.domain.js';
import { questionSchema } from '../question/question.js';

var GradeLevel = /* @__PURE__ */ ((GradeLevel2) => {
  GradeLevel2["PRIMARY"] = "primary";
  GradeLevel2["MIDDLE"] = "middle";
  GradeLevel2["HIGH"] = "high";
  GradeLevel2["UNIV"] = "UNIV";
  GradeLevel2["UKW"] = "";
  return GradeLevel2;
})(GradeLevel || {});
const quizVersionSchema = baseSchema.extend({
  quizId: objectIdSchema.optional(),
  traits: z.object({
    isQuizWithoutCorrectAnswer: z.boolean().default(false),
    totalSlides: z.number().int().default(0)
  }).default({
    isQuizWithoutCorrectAnswer: false,
    totalSlides: 0
  }).optional(),
  name: z.string().max(150).min(1),
  image: z.string().optional(),
  lang: z.string().default("English"),
  visibility: z.boolean().default(true),
  questions: z.array(objectIdSchema).default([]).refine((item) => item.length <= 500).optional(),
  questionDrafts: z.array(objectIdSchema).default([]).refine((item) => item.length <= 500).optional(),
  subjects: z.array(z.string()).default([]),
  topics: z.array(z.string()).default([]),
  subtopics: z.array(z.string()).default([]),
  stateStandards: z.record(z.string(), z.any()).optional(),
  grade: z.array(z.string()).default([]),
  standardsData: z.record(z.string(), z.any()).default({}).optional(),
  gradeLevel: z.nativeEnum(GradeLevel).optional(),
  meta: z.object({
    slot: z.number().int().optional(),
    experiment: z.string().optional()
  }),
  description: z.string().optional(),
  deleted: z.boolean().default(false).optional(),
  cloneList: z.array(objectIdSchema).default([]).optional(),
  standards: z.array(objectIdSchema).default([]).optional(),
  standardIds: z.array(z.unknown()).default([]).optional(),
  courses: z.array(objectIdSchema).default([]),
  pref: z.object({
    time: z.number().optional()
  }).optional(),
  qm: z.record(z.string(), z.any()).optional(),
  theme: themeSchema.optional()
});
const quizVersionFESchema = baseFESchema.merge(quizVersionSchema.extend({
  quizId: isValidObjectIdSchema.optional(),
  aiGenerated: z.boolean().default(false).optional(),
  questions: z.array(questionSchema).default([]),
  questionDrafts: z.array(questionSchema).default([]),
  cloneList: z.array(isValidObjectIdSchema).default([]).optional(),
  standards: z.array(isValidObjectIdSchema).default([]).optional(),
  standardIds: z.array(z.unknown()).default([]).optional(),
  courses: z.array(isValidObjectIdSchema).default([])
}));

export { GradeLevel, quizVersionFESchema, quizVersionSchema };
